import { type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
import type { UsedSource } from "@noa/api-core";
import { normalizeTabsAndLineBreaks } from "@noa/api-client";

interface DocInfoProps {
  used_sources: UsedSource;
}

export const SourceInfo: FunctionComponent<DocInfoProps> = ({ used_sources }) => {
  const { t } = useTranslation();

  const { text, location_information } = used_sources;
  const message = normalizeTabsAndLineBreaks(text);

  return (
    <div>
      <p>
        <strong>{t("chat:reference.location")}</strong> {location_information}
      </p>
      <div
        className="border border-noa rounded-md"
        style={{
          maxHeight: "30vh",
          overflowY: "auto",
          padding: "10px",
        }}
      >
        <Markdown>{message}</Markdown>
      </div>
    </div>
  );
};
